import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, Typography, CircularProgress } from "@mui/material";
import { GET_FORM } from "../../api/form";
import axios from "axios";

const FormTable = () => {
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = async () => {
    try {
      const res = await axios.get(GET_FORM);
      if (res.data.success) {
        const dataWithId = res.data.data.map((item) => ({
          ...item,
          id: item._id, // required for DataGrid
        }));
        setFormData(dataWithId);
      }
    } catch (err) {
      console.error("Error fetching forms:", err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "category", headerName: "Category", width: 150 },
    { field: "firstName", headerName: "First Name", width: 130 },
    { field: "lastName", headerName: "Last Name", width: 130 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phoneNumber", headerName: "Phone", width: 140 },
    { field: "organization", headerName: "Organization", width: 160 },
    { field: "designation", headerName: "Designation", width: 140 },
    { field: "purpose", headerName: "Purpose", width: 160 },
    { field: "companyName", headerName: "Company Name", width: 160 },
    { field: "companyEmail", headerName: "Company Email", width: 200 },
    { field: "query", headerName: "Query", width: 250 },
    { field: "linkedInId", headerName: "LinkedIn ID", width: 180 },
    { field: "markoknowPartner", headerName: "Markoknow Partner", width: 180 },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 180,
      valueGetter: (params) =>
        params.row.createdAt
          ? new Date(params.row.createdAt).toLocaleString()
          : "",
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" mb={2} fontWeight="bold">
        Form Submissions
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={formData}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            slots={{ toolbar: GridToolbar }}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f5f5f5",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default FormTable;
